import { render, staticRenderFns } from "./AddProductPackageDialog.vue?vue&type=template&id=b220959c"
import script from "./AddProductPackageDialog.vue?vue&type=script&lang=ts"
export * from "./AddProductPackageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports